import React from 'react'
import ComponentStyle from '../styles/Components.module.css'

function WhatsApp() {
  return (
    <div className={`${ComponentStyle.title}`}><h1>WhatsApp</h1></div>
  )
}

export default WhatsApp